export default __webpack_public_path__ + "static/media/ShearStressImg.e59e6807.png";